import { render } from "./DetailCarousel.vue?vue&type=template&id=c4cc584a"
import script from "./DetailCarousel.vue?vue&type=script&lang=js"
export * from "./DetailCarousel.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/admin.23paskal.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__